import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/i18n'
import './index.css'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import App from './App.tsx'
import { initSentry, Sentry } from '@/config/sentry'

// Must run before React renders so the earliest errors are captured.
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <h2>Coś poszło nie tak.</h2>
          <p>Odśwież stronę. Jeśli problem się powtarza, daj nam znać — błąd został zgłoszony automatycznie.</p>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
